import React, {Component} from 'react';
import Icon from './Icon';
import './StatusIcon.css';
export default class StatusIcon extends Component{


	getStatusIcon(){
		let icon = 'none';
		let color = '';
		switch(this.props.status.toLowerCase()){
		case 'booked':
			icon = '';
			break;
		case 'confirmed':
			icon = 'confirmed';
			break;
		case 'cancelled':
			icon = 'cancelled';
			break;
		case 'no-show':
			icon = 'cancelled';
			break;
		case 'completed':
			icon = 'confirmed';
			color='svg-fill-purple'
			break;
		default:

			break;
		}

		return <Icon className={"status " + color} icon={icon} />
	}

	render(){
		return(
			<div className="status-icon">
				<Icon {... this.props} />
				{this.getStatusIcon()}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/StatusIcon.js